var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonVideoGallery/CommonVideoGallery.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonVideoGallery/CommonVideoGallery.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"CommonVideoGallery\">\n        <h2 class=\"CommonVideoGallery-header\">More from ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
t_5 += " <span class=\"CommonVideoGallery-headerSlash\">/</span> <span class=\"CommonVideoGallery-headerCount\">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sourcesCount"), env.opts.autoescape);
t_5 += " videos</span></h2>\n\n        <div class=\"CommonVideoGallery-gallery\">\n            <div class=\"CommonVideoGallery-galleryWrapper\">\n                <div class=\"CommonVideoGallery-galleryPlaceholder\"  data-animation=\"1\" data-animation-type=\"bubble-down\" data-animation-state=\"initial\">\n                    <div class=\"CommonVideoGallery-galleryCarousel owl-carousel owl-theme\">\n                        ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"sources");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                            <div class=\"CommonVideoGallery-item";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
t_5 += " play";
;
}
t_5 += "\" data-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
t_5 += "\">\n                                <figure>\n                                    <div class=\"CommonVideoGallery-itemPreview\">\n                                        <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"cover")),"w560_url"), env.opts.autoescape);
t_5 += "\"\n                                          srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"cover")),"w680_url"), env.opts.autoescape);
t_5 += " 2x\"\n                                          alt=\"\">\n                                        <div class=\"CommonVideoGallery-itemBtnPlayWrapper\">\n                                            <div class=\"CommonVideoGallery-itemBtnPlay\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"CommonVideoGallery-itemTitle\">\n                                        ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "\n                                    </div>\n                                    <div class=\"CommonVideoGallery-itemInfo\">\n                                        ";
if(runtime.memberLookup((t_9),"duration")) {
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"duration"), env.opts.autoescape);
;
}
t_5 += "\n                                    </div>\n                                </figure>\n                            </div>\n                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                    </div>\n\n                    <div class=\"CommonVideoGallery-galleryPrev\">\n                        ";
t_5 += runtime.suppressValue((lineno = 33, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["gallery-arrow-prev","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_5 += "\n                    </div>\n\n                    <div class=\"CommonVideoGallery-galleryNext\">\n                        ";
t_5 += runtime.suppressValue((lineno = 37, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["gallery-arrow-next","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_12 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_13 = "";;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
return macro_t_12;})()})])), env.opts.autoescape);
t_5 += "\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("CommonVideoGallery");
context.setVariable("CommonVideoGallery", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonVideoGallery/CommonVideoGallery.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonVideoGallery/CommonVideoGallery.jinja
// module id = 97
// module chunks = 0